/* Japan Motor Import — collection filter sidebar (Southbay-style, instant, in the browser).
   Loaded after theme.js on collection pages only (layout/theme.liquid). Uses window.JMI from theme.js. */
(function () {
  'use strict';
  var J = window.JMI; if (!J) return;
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };
  var on = function (el, ev, fn) { if (el) el.addEventListener(ev, fn); };
  var handle = J.handle, vehicleData = J.vehicleData, fillModelSelect = J.fillModelSelect, fillMakeSelect = J.fillMakeSelect;

  /* ---------- Collection filter sidebar (instant, in the browser) ---------- */
  function initCollectionFilter(root) {
    var grid = $('[data-pf-grid]', root); if (!grid) return;
    var S = {}; try { S = JSON.parse($('[data-pf-strings]', root).textContent); } catch (e) { S = {}; }
    var fmt = function (s, o) { return String(s || '').replace(/\[(\w+)\]/g, function (m, k) { return o[k] != null ? o[k] : m; }); };
    var cur = S.currency || '$';
    var dollars = function (v) { return cur + Number(v).toLocaleString('en-US', { maximumFractionDigits: 2 }); };
    var per = parseInt(root.dataset.perPage, 10) || 12;
    var items = $$('[data-pf-item]', grid).map(function (el, i) {
      var d = el.dataset;
      return {
        el: el, i: i, sku: parseInt(d.sku, 10) || 0, price: parseInt(d.price, 10) || 0, avail: d.avail === '1',
        make: d.make || '', model: d.model || '', years: (d.years || '').split(/\s+/).filter(Boolean), cond: d.cond || '',
        cats: (d.cats || '').split(/\s+/).filter(Boolean), created: parseInt(d.created, 10) || 0, name: d.name || '', q: d.q || ''
      };
    });
    var ui = {
      sidebar: $('[data-pf-sidebar]', root), backdrop: $('.pf-backdrop', root),
      search: $('[data-pf-search]', root), year: $('[data-pf-year]', root), make: $('[data-pf-make]', root), model: $('[data-pf-model]', root),
      min: $('[data-pf-min]', root), max: $('[data-pf-max]', root), stock: $('[data-pf-stock]', root), sort: $('[data-pf-sort]', root),
      cats: $$('[data-pf-cat]', root), conds: $$('[data-pf-cond]', root),
      count: $('[data-pf-count]', root), chips: $('[data-pf-chips]', root), empty: $('[data-pf-empty]', root),
      pager: $('[data-pf-pager]', root), pagerInfo: $('[data-pf-pager-info]', root), pages: $('[data-pf-pages]', root),
      show: $$('[data-pf-show]', root), openBtn: $('[data-pf-open]', root), activeN: $('[data-pf-active-n]', root)
    };
    var modelPh = S.allModels || (ui.model && ui.model.options[0] ? ui.model.options[0].textContent : '');
    fillMakeSelect(ui.make);

    /* Category counts (fixed, like the old site) */
    ui.cats.forEach(function (cb) {
      var n = 0; items.forEach(function (it) { if (it.cats.indexOf(cb.value) > -1) n++; });
      var c = $('[data-pf-cat-count="' + cb.value + '"]', root); if (c) c.textContent = '(' + n + ')';
    });

    var st;
    function num(v) { v = parseFloat(v); return isNaN(v) || v < 0 ? '' : v; }
    function read() {
      var p = new URLSearchParams(location.search);
      function list(key) {
        var out = [], re = new RegExp('^' + key + '\\[\\d*\\]$');
        (p.get(key) || '').split(',').forEach(function (v) { v = v.trim().toLowerCase(); if (v) out.push(v); });
        p.forEach(function (v, k) { if (re.test(k) && v) out.push(v.trim().toLowerCase()); });
        return out.filter(function (v, i, a) { return a.indexOf(v) === i; });
      }
      var legacy = { 'created-descending': 'newest', 'price-ascending': 'price_asc', 'price-descending': 'price_desc', 'title-ascending': 'name_asc', 'title-descending': 'name_desc' };
      var sort = p.get('sort') || legacy[p.get('sort_by')] || 'newest';
      if (!/^(newest|price_asc|price_desc|name_asc|name_desc)$/.test(sort)) sort = 'newest';
      st = {
        search: (p.get('search') || p.get('q') || '').trim(),
        year: (p.get('year') || '').replace(/\D/g, ''),
        make: handle(p.get('make') || ''),
        model: handle(p.get('model') || ''),
        cats: list('category'),
        min: num(p.get('minPrice')), max: num(p.get('maxPrice')),
        conds: list('condition'),
        stock: /^(1|true|on|yes)$/i.test(p.get('inStock') || ''),
        sort: sort,
        pg: Math.max(1, parseInt(p.get('pg'), 10) || 1)
      };
    }
    function write(push) {
      var p = new URLSearchParams();
      if (st.search) p.set('search', st.search);
      if (st.year) p.set('year', st.year);
      if (st.make) p.set('make', st.make);
      if (st.model) p.set('model', st.model);
      if (st.cats.length) p.set('category', st.cats.join(','));
      if (st.min !== '') p.set('minPrice', st.min);
      if (st.max !== '') p.set('maxPrice', st.max);
      if (st.conds.length) p.set('condition', st.conds.join(','));
      if (st.stock) p.set('inStock', 'true');
      if (st.sort !== 'newest') p.set('sort', st.sort);
      if (st.pg > 1) p.set('pg', st.pg);
      var qs = p.toString();
      try { history[push ? 'pushState' : 'replaceState'](null, '', location.pathname + (qs ? '?' + qs : '') + location.hash); } catch (e) {}
    }
    function ensureOption(sel, val, label) {
      if (!sel || !val) return;
      sel.value = val;
      if (sel.value !== val) { sel.appendChild(new Option(label || val, val)); sel.value = val; }
    }
    function sync() {
      if (ui.search) ui.search.value = st.search;
      if (ui.year) { ui.year.value = ''; ensureOption(ui.year, st.year); }
      if (ui.make) { ui.make.value = ''; ensureOption(ui.make, st.make, st.make.replace(/-/g, ' ')); }
      fillModelSelect(ui.model, st.make, modelPh, st.model);
      ui.cats.forEach(function (cb) { cb.checked = st.cats.indexOf(cb.value) > -1; });
      if (ui.min) ui.min.value = st.min;
      if (ui.max) ui.max.value = st.max;
      ui.conds.forEach(function (cb) { cb.checked = st.conds.indexOf(cb.value) > -1; });
      if (ui.stock) ui.stock.checked = st.stock;
      if (ui.sort) ui.sort.value = st.sort;
    }
    function match(it) {
      if (st.search) {
        var terms = st.search.toLowerCase().split(/\s+/).filter(Boolean);
        for (var t = 0; t < terms.length; t++) if (it.q.indexOf(terms[t]) < 0) return false;
      }
      if (st.year && it.years.indexOf(st.year) < 0) return false;
      if (st.make && it.make !== st.make) return false;
      if (st.model && it.model !== st.model) return false;
      if (st.cats.length && !st.cats.some(function (c) { return it.cats.indexOf(c) > -1; })) return false;
      if (st.min !== '' && it.price < st.min * 100) return false;
      if (st.max !== '' && it.price > st.max * 100) return false;
      if (st.conds.length && st.conds.indexOf(it.cond) < 0) return false;
      if (st.stock && !it.avail) return false;
      return true;
    }
    function byNewest(a, b) { return (b.sku - a.sku) || (b.created - a.created) || (a.i - b.i); }
    function cmp(a, b) {
      switch (st.sort) {
        case 'price_asc': return (a.price - b.price) || byNewest(a, b);
        case 'price_desc': return (b.price - a.price) || byNewest(a, b);
        case 'name_asc': return a.name.localeCompare(b.name, undefined, { numeric: true }) || byNewest(a, b);
        case 'name_desc': return b.name.localeCompare(a.name, undefined, { numeric: true }) || byNewest(a, b);
        default: return byNewest(a, b);
      }
    }
    function labelOf(list, val) {
      for (var i = 0; i < list.length; i++) if (list[i].value === val) return list[i].dataset.label || val;
      return val.replace(/-/g, ' ');
    }
    function chips() {
      if (!ui.chips) return 0;
      var out = [], vd = vehicleData();
      var add = function (k, v, text) { out.push('<button type="button" class="pf-chip" data-k="' + k + '" data-v="' + String(v).replace(/"/g, '&quot;') + '">' + text.replace(/</g, '&lt;') + ' <span aria-hidden="true">&times;</span></button>'); };
      if (st.search) add('search', '', (S.search || 'Search') + ': ' + st.search);
      if (st.year) add('year', '', (S.year || 'Year') + ': ' + st.year);
      if (st.make) add('make', '', (S.make || 'Make') + ': ' + (vd.byHandle[st.make] ? vd.byHandle[st.make].name : st.make));
      if (st.model) add('model', '', (S.model || 'Model') + ': ' + (ui.model && ui.model.selectedIndex > 0 ? ui.model.options[ui.model.selectedIndex].text : st.model));
      st.cats.forEach(function (c) { add('cat', c, labelOf(ui.cats, c)); });
      if (st.min !== '' || st.max !== '') {
        var pr = st.min !== '' && st.max !== '' ? dollars(st.min) + ' - ' + dollars(st.max) : (st.min !== '' ? dollars(st.min) + '+' : dollars(0) + ' - ' + dollars(st.max));
        add('price', '', (S.price || 'Price') + ': ' + pr);
      }
      st.conds.forEach(function (c) { add('cond', c, labelOf(ui.conds, c)); });
      if (st.stock) add('stock', '', S.inStock || 'In Stock Only');
      var n = out.length;
      if (n) out.push('<button type="button" class="pf-chip pf-chip--clear" data-k="all">' + (S.clearAll || 'Clear All') + '</button>');
      ui.chips.innerHTML = out.join('');
      ui.chips.hidden = !n;
      return n;
    }
    function pageList(pg, pages) {
      var set = [1, pages, pg - 1, pg, pg + 1].filter(function (n) { return n >= 1 && n <= pages; });
      set = set.filter(function (v, i, a) { return a.indexOf(v) === i; }).sort(function (a, b) { return a - b; });
      var out = [];
      set.forEach(function (n, i) { if (i && n - set[i - 1] > 1) out.push(0); out.push(n); });
      return out;
    }
    function pager(total, pages, start, end) {
      if (!ui.pager) return;
      ui.pager.hidden = pages <= 1;
      if (pages <= 1) return;
      ui.pagerInfo.textContent = fmt(S.results, { from: start + 1, to: end, total: total });
      var chev = '<svg class="icon" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m6 9 6 6 6-6"/></svg>';
      var h = '<button type="button" class="pagination__btn' + (st.pg === 1 ? ' is-disabled' : '') + '" data-pg="' + (st.pg - 1) + '" aria-label="' + (S.previous || 'Previous') + '">' + chev + '</button>';
      pageList(st.pg, pages).forEach(function (n) {
        h += n ? '<button type="button" class="pagination__num' + (n === st.pg ? ' is-active" aria-current="page' : '') + '" data-pg="' + n + '">' + n + '</button>' : '<span class="pagination__num is-gap">&hellip;</span>';
      });
      h += '<button type="button" class="pagination__btn pagination__btn--next' + (st.pg === pages ? ' is-disabled' : '') + '" data-pg="' + (st.pg + 1) + '" aria-label="' + (S.next || 'Next') + '">' + chev + '</button>';
      ui.pages.innerHTML = h;
    }
    function render() {
      var res = items.filter(match).sort(cmp);
      var total = res.length, pages = Math.max(1, Math.ceil(total / per));
      if (st.pg > pages) st.pg = pages;
      var start = (st.pg - 1) * per, end = Math.min(total, start + per);
      var frag = document.createDocumentFragment();
      items.forEach(function (it) { it.on = false; });
      res.forEach(function (it, k) { it.on = true; it.el.hidden = k < start || k >= end; frag.appendChild(it.el); });
      items.forEach(function (it) { if (!it.on) { it.el.hidden = true; frag.appendChild(it.el); } });
      grid.appendChild(frag);
      grid.hidden = !total;
      if (ui.empty) ui.empty.hidden = total > 0;
      if (ui.count) ui.count.textContent = total === 1 ? (S.showingOne || 'Showing 1 product') : fmt(S.showing, { count: total });
      ui.show.forEach(function (b) { b.textContent = fmt(S.showResults, { count: total }); });
      pager(total, pages, start, end);
      var n = chips();
      if (ui.activeN) { ui.activeN.hidden = !n; ui.activeN.textContent = n; }
    }
    function update(push) { st.pg = 1; write(push); render(); }
    function clearAll() { st.search = ''; st.year = ''; st.make = ''; st.model = ''; st.cats = []; st.min = ''; st.max = ''; st.conds = []; st.stock = false; sync(); update(); }
    var tm = {};
    function later(key, ms, fn) { clearTimeout(tm[key]); tm[key] = setTimeout(fn, ms); }

    on(ui.search, 'input', function () { later('s', 300, function () { st.search = ui.search.value.trim(); update(); }); });
    on(ui.search, 'search', function () { st.search = ui.search.value.trim(); update(); });
    on(ui.year, 'change', function () { st.year = ui.year.value; update(); });
    on(ui.make, 'change', function () { st.make = ui.make.value; st.model = ''; fillModelSelect(ui.model, st.make, modelPh); update(); });
    on(ui.model, 'change', function () { st.model = ui.model.value; update(); });
    ui.cats.forEach(function (cb) { on(cb, 'change', function () { st.cats = ui.cats.filter(function (c) { return c.checked; }).map(function (c) { return c.value; }); update(); }); });
    ui.conds.forEach(function (cb) { on(cb, 'change', function () { st.conds = ui.conds.filter(function (c) { return c.checked; }).map(function (c) { return c.value; }); update(); }); });
    on(ui.min, 'input', function () { later('p', 500, function () { st.min = num(ui.min.value); update(); }); });
    on(ui.max, 'input', function () { later('p', 500, function () { st.max = num(ui.max.value); update(); }); });
    on(ui.stock, 'change', function () { st.stock = ui.stock.checked; update(); });
    on(ui.sort, 'change', function () { st.sort = ui.sort.value; update(); });
    $$('[data-pf-clear]', root).forEach(function (b) { on(b, 'click', function (e) { e.preventDefault(); clearAll(); }); });
    on(ui.chips, 'click', function (e) {
      var c = e.target.closest('.pf-chip'); if (!c) return;
      var k = c.dataset.k, v = c.dataset.v;
      if (k === 'all') { clearAll(); return; }
      if (k === 'search') st.search = '';
      if (k === 'year') st.year = '';
      if (k === 'make') { st.make = ''; st.model = ''; }
      if (k === 'model') st.model = '';
      if (k === 'cat') st.cats = st.cats.filter(function (x) { return x !== v; });
      if (k === 'price') { st.min = ''; st.max = ''; }
      if (k === 'cond') st.conds = st.conds.filter(function (x) { return x !== v; });
      if (k === 'stock') st.stock = false;
      sync(); update();
    });
    on(ui.pages, 'click', function (e) {
      var b = e.target.closest('[data-pg]'); if (!b || b.classList.contains('is-disabled')) return;
      st.pg = parseInt(b.dataset.pg, 10) || 1; write(true); render();
      var top = (root.querySelector('.collection__main') || root).getBoundingClientRect().top + window.pageYOffset - 130;
      window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
    });

    /* Mobile drawer */
    function drawer(open) {
      if (!ui.sidebar) return;
      ui.sidebar.classList.toggle('is-open', open);
      if (ui.backdrop) ui.backdrop.hidden = !open;
      document.body.classList.toggle('pf-lock', open);
      if (ui.openBtn) ui.openBtn.setAttribute('aria-expanded', open);
    }
    on(ui.openBtn, 'click', function () { drawer(true); });
    $$('[data-pf-close]', root).forEach(function (b) { on(b, 'click', function () { drawer(false); }); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && ui.sidebar && ui.sidebar.classList.contains('is-open')) drawer(false); });
    window.addEventListener('popstate', function () { read(); sync(); render(); });

    read(); sync(); render();
    root.classList.add('pf--ready');
  }
  $$('[data-pf]').forEach(initCollectionFilter);
})();